<div class="main-content">
    <app-nav>
        <router-outlet></router-outlet>
    </app-nav>
</div>